<template>
    <label :class="{ 'button-view': buttonView }" class="attach-handler">
        <AttachIcon v-if="!fileLoading" width="24" height="24" />
        <SpinLoader style="margin: 0 !important" :width="24" v-else />

        <default-title class="ml-8" small :font-weight="400" v-if="buttonView">
            {{ t("course.practice.attach_file") }}
        </default-title>
        <input
            class="attach-handler__input"
            type="file"
            hidden
            name="file"
            :multiple="multiple"
            ref="file"
            accept="*.*"
            @change="handleFileUpload"
        />
    </label>
</template>

<script>
import AttachIcon from "@icons/AttachIcon.vue"

import { createFileTask } from "@components/Files/FileTasks.vue"
import { EventBus } from "~events"
import SpinLoader from "@components/Loaders/SpinLoader.vue"
import DefaultTitle from "@components/Typography/DefaultTitle.vue"

export default {
    props: {
        appModel: {
            type: String,
            default: "comment"
        },
        buttonView: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: true
        }
    },
    name: "UploadFile",
    components: { DefaultTitle, SpinLoader, AttachIcon },
    data() {
        return {
            file: null,
            title: "",
            fileLoading: false
        }
    },
    created() {
        this.title = document.title
    },
    methods: {
        async handleFileUpload(e) {
            EventBus.$emit("fileLoading", true)

            this.fileLoading = true

            createFileTask(e.target.files)
                .then(result => {
                    for (const resultElement of result) {
                        if (resultElement.status === "fulfilled") {
                            this.$emit("save", resultElement.value)
                        }
                    }
                })
                .finally(() => {
                    this.$refs.file.value = null
                    this.fileLoading = false
                    EventBus.$emit("fileLoading", false)
                })
        }
    }
}
</script>

<style scoped lang="sass">
.attach-handler
    cursor: pointer
    width: 30px
    height: 30px
    display: flex
    align-items: center
    justify-content: center
    border-radius: 4px
    background-color: #fff
    transition: .2s
    z-index: 2
    @media screen and (max-width: 640px)
        width: 24px
        height: 24px
    &:hover
        background-color: #F2F7FF
    &.button-view
        width: 100%
</style>
